// Full website search is opt-in; older hosts default to catalog suggestions.
export function getSearchFeatures () {
    const features = window.upi?.conf?.features || {};

    return {
        fullSite: features.SearchFullSite === true,
        suggestions: features.SearchSuggestions !== false
    };
}
